__turbopack_context__.v({
  "bar": "_5WVGHq_bar",
  "counter": "_5WVGHq_counter",
  "counter-wrapper": "_5WVGHq_counter-wrapper",
  "placeholder": "_5WVGHq_placeholder",
  "unit": "_5WVGHq_unit",
  "value": "_5WVGHq_value",
  "wrapper": "_5WVGHq_wrapper",
});
